import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { HttpHelper } from '@ppvrbh/merchant-frontend-core';

// Init http instance once
HttpHelper.createInstance({
  // Default axios configuration
});

ReactDOM.render(<App />, document.getElementById('root'));
